import { LayoutRouteProps, PathRouteProps } from 'react-router-dom';
import { RouteBaseProps } from './types';

export type PatternsReactProps = (PathRouteProps | LayoutRouteProps) &
  RouteBaseProps;

export const PatternsReactRoute = (_props: PatternsReactProps) => {
  return null;
};
